
export const ebasReportVersion = 4;